module.exports = __webpack_public_path__ + "static/img/global_warning_active.07d567f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global_warning_active.png
// module id = Ewyi
// module chunks = 101